import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";
import allOutgoingPaymentsService from "../services/allOutgoingPayments";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  prefilledData: {},
  apiData: {},
  startDate: null,
  endDate: null,
  externalOrderId: null,
  settlementIds: null,
  created_at: null,
  updated_at: null,
  isFilterApplied: false,
  isDateFilterApplied: false,
  page: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("allOutgoingPaymentManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchAllOutgoingPayments", "list"),
    updateStartDate(state, action) {
      state.startDate = action.payload;
    },
    updateEndDate(state, action) {
      state.endDate = action.payload;
    },
    updateCreatedAt(state, action) {
      state.created_at = action.payload;
    },
    updateUpdatedAt(state, action) {
      state.updated_at = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    updateDateFilterButton(state, action) {
      state.isDateFilterApplied = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    updatePrefilledData(state, action) {
      state.prefilledData = action.payload;
    },
    updateApiData(state, action) {
      state.apiData = action.payload;
    },
    updateExternalOrderId(state, action) {
      state.externalOrderId = action.payload;
    },
    updateSettlementIds(state, action) {
      state.settlementIds = action.payload;
    },
  },
});

const fetchAllOutgoingPaymentList = createAsyncSaga(
  "fetchAllOutgoingPayments",
  Slice,
  allOutgoingPaymentsService.fetchAllOutgoingPayments,
  [
    "shopId",
    "currentPage",
    "itemsPerPage",
    "startDate",
    "endDate",
    "externalOrderId",
    "settlementIds",
    "created_at",
    "updated_at",
  ]
);

addSaga(
  Slice.actions.fetchAllOutgoingPayments.type,
  fetchAllOutgoingPaymentList
);

export const {
  fetchAllOutgoingPayments,
  updateStartDate,
  updateEndDate,
  updateCreatedAt,
  updateUpdatedAt,
  updateFilterButton,
  setPage,
  updateDateFilterButton,
  updatePrefilledData,
  updateApiData,
  updateExternalOrderId,
  updateSettlementIds,
} = Slice.actions;

export default Slice.reducer;
